module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_7016.f16f340c.png";